module.exports = __webpack_public_path__ + "img/1440.d15b8c0b.jpg";